<template>
  <div class="card card-fluid">
    <div class="card-header">
      <div class="d-flex align-items-center">
        <span class="mr-auto">Job Title</span>
      </div>
    </div><!-- /.card-header -->
    <div class="card-body">
      <div id="data-table-leave-request-request_wrapper" class="dataTables_wrapper dt-bootstrap4 no-footer">
        <b-table :items="items" :fields="fields" :sticky-header="stickyHeader" :no-border-collapse="noCollapse"  :sort-direction="sortDirection" :sort-by.sync="sortBy"
                 :sort-desc.sync="sortDesc" responsive  table-class="dt-responsive nowrap w-100 dataTable no-footer dtr-inline" hover :class="{'hide-scroll': isScrollHide()}">
          <template v-slot:cell(action)="row">
            <a class="btn btn-xs"  @click="detailRow(row.item, row.index, $event.target)" title="Detail">
              <em class="fa fa-search"></em>
            </a>
          </template>
        </b-table>
        <div class="row align-items-center">
          <div class="col-sm-12 col-md-5">
            <div class="dataTables_info" id="data-table-leave-request-request_info" role="status" aria-live="polite">Showing {{currentPage}} to {{perPage}} of {{rows}} entries</div>
          </div>
          <div class="col-sm-12 col-md-7 d-flex justify-content-end">
            <div class="dataTables_paginate paging_simple_numbers">
              <b-pagination v-model="currentPage" v-on:click="getData"  :per-page="perPage"  :total-rows="rows" ></b-pagination>
            </div>
          </div>
        </div>
        <functional-position-input></functional-position-input>
        <functional-position-detail-form :data="data" ref="mdl-det"></functional-position-detail-form>
      </div>
    </div>
  </div>
</template>

<script>
import {BTable, BPagination, VBModal} from "bootstrap-vue"
import {mapGetters} from "vuex";
import FunctionalPositionInput from "@/components/pages/functional-position/FunctionalPositionInput";
import AxiosCall from "../../../../libs/AxiosCall";
import {urlApi} from "../../../../config/url-api";
import FunctionalPositionDetailForm from "./FunctionalPositionDetailForm";
export default {
  name: "FunctionalPositionDetail",
  components:{
    FunctionalPositionDetailForm,
    FunctionalPositionInput,
    BTable,
    BPagination
  },
  directives:{
    'b-modal':VBModal
  },
  data(){
    return {
      noCollapse:false,
      stickyHeader: true,
      sortDirection: 'asc',
      sortBy: '',
      sortDesc: false,
      items:[],
      fields: [
        { key: 'no', sortable: true , thStyle: {maxWidth: '60px', minWidth: '10px'}},
        { key: 'action', sortable: true, thStyle: {maxWidth: '150px', minWidth: '10px'} },
        { key: 'position_name', label:'Job Title', sortable: true},
        { key: 'valid_from',label:'Date of Issue', sortable: true },
        { key: 'valid_until',label:"Expiration Date", sortable: true },
        { key: 'last_modified', sortable: true },
      ],
      rows:0,
      perPage:5,
      currentPage:1,
      data:null
    }
  },
  watch:{
    currentPage:function (){
      this.getData()
    }
  },
  computed:{
    ...mapGetters([ 'scrollbarHide']),
  },
  methods:{
    isScrollHide(){
      return this.scrollbarHide
    },
    getData(){
      this.items = []
      let payload = {
        page : this.currentPage,
        limit: this.perPage,
        emp_id : this.$store.getters.empId
      }
      AxiosCall.Get(payload, urlApi.job_title.index).then(res=>{
        if(res.success){
          let no = (this.currentPage - 1) * this.perPage +1

          for (let data of res.atributes){
            data.no = no++
            this.items.push(data)
          }
          this.rows = res.total
        }else{
          this.errorMessage(res.message)
        }
      }).catch(e=>{
        this.errorMessage(e.response.data.message)
      })
    },
    successMessage(title){
      this.$bvToast.toast(title, {
        title: `Success`,
        variant: 'success',
        solid: true
      })
    },
    errorMessage(title){
      this.$bvToast.toast(title, {
        title: `Error`,
        variant: 'danger',
        solid: true
      })
    },
    editRow(item){
      this.data = item
      this.$refs.mdl.$refs.modal.show()
    },
    detailRow(item){
      this.data = item
      this.$refs["mdl-det"].$refs.modal.show()
    },
    deleteRow(item){
      this.data = item
      this.$refs["modal-delete"].show()
    },
    deleteItem(){
      AxiosCall.Delete(urlApi.tax_payer.delete+"/"+this.data.id).then(res=>{
        if (res.success){
          this.successMessage(res.message)
          this.getData()
          this.$refs["modal-delete"].hide()
        }else{
          this.errorMessage(res.message)
        }
      }).catch(e=>{
        console.log(JSON.stringify(e))
        this.errorMessage(e.response.data.message)
      })
    },
    resetModal(){
      this.data = null
    },
  },
  created() {
    this.getData()
  }
}
</script>